module.exports = __webpack_public_path__ + "static/GorditaMedium-Italic-4e052dc976854f5f12deb2f64a21c688.woff2";